import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Link, useNavigate } from 'react-router-dom';
import styles from './onBoardingMobile.module.scss';
import { Pager } from '../dumb/pager';
import { OnboardingContent } from '../dumb/onBoardingContent.dumb';
import {
  OnBoardingStepsImage,
  OnBoardingStepsText,
} from '../helper/onBoardingHelper';
import { ImageCarousel } from '../../../../components/imageCarousel/imageCarousel';
import players from '../../../../assets/img/Players.png';
import teamManager from '../../../../assets/img/TeamManager.png';
import automaticNotifications from '../../../../assets/img/AutomaticNotifications.png';
import guardianTelehealthAppt from '../../../../assets/img/GuardianTelehealthAppt.png';
import logo from '../../../../assets/img/conneqt_logo.png';
import { Button } from '../../../../components/button/button';
import { ConneqtLogo } from '../../../../components/logo/logo';

export const OnBoardingMobile = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  const items = [
    { image: players, text: t('onboarding.ONBOARDING_1') },
    { image: teamManager, text: t('onboarding.ONBOARDING_2') },
    { image: automaticNotifications, text: t('onboarding.ONBOARDING_3') },
    { image: guardianTelehealthAppt, text: t('onboarding.ONBOARDING_4') },
  ];

  return (
    <>
      <ConneqtLogo />
      <ImageCarousel items={items} />
      <div className={styles.actions}>
        <Button
          type="submit"
          fullWidth
          label={t('SIGN_IN').toString()}
          color="secondary"
          variant="contained"
          onClick={() => {
            navigate('/login');
          }}
        />
        <Link to="/signup" className={styles.signUp}>
          {t('SIGNUP_GUARDIAN')}
        </Link>
      </div>
    </>
  );
};
